import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncSupportParishDetails({ ...rest }) {
  const AsyncLoad = loadable(() => import("../supportParishDetailsPage"));
  console.log("Loading", AsyncSupportParishDetails.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncSupportParishDetails;
